import request from '@/router/axios'
import env from '@/config/env'
/**
 * 发送验证码
 * @param param
 */
export const getSmsCode = (param = {}) => {
  return request({
    url: env.loginUrl + '/sms',
    method: 'GET',
    params: {
      ...param
    }
  })
}

/**
 * 电话号码登陆
 * @param param
 */
export const loginBySmsCode = (param = {}) => {
  return request({
    url: env.loginUrl + '/oauth/token',
    method: 'POST',
    params: {
      ...param
    }
  })
}

/**
 * 刷新令牌
 * @param {刷新token} rtoken
 */
export const refreshToken = (rtoken) => {
  return request({
    url: env.loginUrl + '/oauth/token',
    method: 'POST',
    params: {
      grant_type: 'refresh_token',
      client_id: 'api-boss',
      client_secret: '123456',
      refresh_token: rtoken
    }
  })
}

/**
 * 2024.02 登录优化-获取验证码
 * @param {*} params
 * @returns
 */
export const sendSmsCode = (data) => {
  return request({
    url: env.loginUrl + '/sms-code-verify',
    method: 'POST',
    data
  })
}

/**
 * 重置密码时发送验证码
 */
export const resetPwdSendSmsCode = (params) => {
  return request({
    url: env.ferryUrl + '/user/smsCode/resetPwd',
    method: 'GET',
    params
  })
}

/**
 * 通过手机验证码重置密码
 * @param {*} data
 * @returns
 */
export const resetPasswordBySmsCode = (params) => {
  return request({
    url: env.ferryUrl + '/user/resetPassword',
    method: 'POST',
    params
  })
}

/**
 * 获取登录二维码
 * @param {*} params
 * @returns
 */
export const queryLoginQrCode = (params) => {
  return request({
    url: env.loginUrl + '/qr-code',
    method: 'GET',
    params
  })
}

/**
 * 获取登录二维码状态
 * @param {*} params
 * @returns
 */
export const queryLoginQrCodeStatus = (params) => {
  return request({
    url: env.loginUrl + '/qr-code-login',
    method: 'POST',
    params
  })
}

/**
 * 获取社交授权跳转url
 * @param {*} params
 * @returns
 */
export const socialAuthRedirect = (params) => {
  return request({
    url: env.loginUrl + '/social-auth-redirect',
    method: 'GET',
    params
  })
}

/**
 * 社交快捷登录
 * @param {*} params
 * @returns
 */
export const socialLogin = (data) => {
  return request({
    url: env.loginUrl + '/social-login',
    method: 'POST',
    data
  })
}

/**
 * 社交绑定
 * @param {*} data
 * @returns
 */
export const socialBind = (data) => {
  return request({
    url: env.ferryUrl + '/user/social-bind',
    method: 'POST',
    data
  })
}

/**
 * 解绑社交绑定
 * @param {*} params
 * @returns
 */
export const socialUnBind = (params) => {
  return request({
    url: env.ferryUrl + '/user/social-unbind',
    method: 'PUT',
    params
  })
}

/**
 * 验证码校验
 * @param {*} params
 * @returns
 */
export const codeVerify = (data) => {
  return request({
    url: env.loginUrl + '/code-verify',
    method: 'POST',
    data
  })
}
